"use client";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { mobileHeaderHeightAtom } from "@/hooks/layoutAtoms";

const MobileHeaderHeightSetter: React.FC<{ height: number }> = ({ height }) => {
  const [, setHeight] = useAtom(mobileHeaderHeightAtom);
  useEffect(() => {
    setHeight(height);
  }, [height, setHeight]);
  return null;
};

export default MobileHeaderHeightSetter;